
import { simpleActionCreator } from '../utils/store.util';
import { CORE_ACTIONS } from '../constants/core-actions.constant';

export const clearAllCachedItems = simpleActionCreator<string>(CORE_ACTIONS.CLEAR_ALL_CACHED_ITEMS);
